import { useFileUpload } from "@yoonhaemin-lib/use-file-upload";
import { useEffect, useState } from "react";
import fileToDataUrl from "utils/fileToDataUrl";

const useSignImage = (initialData?: File | string) => {
  const { files, fileInputProps, inputFor, removeFile, isError } =
    useFileUpload({
      types: ["image/png", "image/jpeg"],
      size: 0.2,
    });

  const [imageSrc, setImageSrc] = useState<string | null>(
    typeof initialData === "string" ? initialData : null,
  );

  const handleSignDelete = () => {
    removeFile(0);
    setImageSrc(null);
  };

  useEffect(() => {
    if (files && files.length !== 0) {
      fileToDataUrl(files[0]).then(setImageSrc);
    }
  }, [files, imageSrc]);

  return {
    signFile: files?.[0],
    imageSrc,
    fileInputProps,
    inputFor,
    isError,
    handleSignDelete,
  };
};

export default useSignImage;
